<template>
  <div :class="classes">
        <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" ref="table" v-loading="loading" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels">
            <template slot="before">
              <el-table-column label="序号" header-align="center" :fit="false" fixed="left" align="center" min-width="50">
                    <template slot-scope="scope">
                       {{scope.row.number}}
                    </template>
                </el-table-column>
                <el-table-column  min-width="240" label="新闻标题" header-align="center" :fit="false" fixed="left" align="center" >
                    <template slot-scope="scope">
                        <div :class="$style['news-price-name']">
                            <div :class="$style['banner-picture-div']">
                            <pt-img :class="$style['banner-picture']"
                            :src="scope.row.mainPicture" styleName="mall-goods-banner-pictures"></pt-img>
                            </div>
                             <div :class="$style['news-name']">
                                {{scope.row.title}}
                             </div>
                        </div>
                    </template>
                </el-table-column>
            </template>
            <template>
              <slot/>
            </template>
          </wt-table>
        </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-news-table'

export default {
  name: 'pt-news-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getNewsList', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.mainPicture{
  width: 75px;
  height: 63px;
}
.news-price-name{
    display: flex;
    line-height: inherit;
    width: 100%;
    padding: 10px;
}
.banner-picture-div{
    display: flex;
    justify-content: center;
    align-items: center;
}
.banner-picture{
    :global
        img{
            max-width: 100px;
            border-radius: 10px;
        }
}
.news-name{
    padding-left: 10px;
    text-align: left
}
</style>
